const fromVite = (key) => {
  try {
    return import.meta.env?.[key];
  } catch {
    return undefined;
  }
};

export const env = {
  adminApi: fromVite('VITE_ADMIN_API'),
  wsUrl:
    fromVite('VITE_WS_URL') ||
    'wss://4c1yn1fja7.execute-api.eu-central-1.amazonaws.com/staging/',
  awsProjectRegion: fromVite('VITE_AWS_PROJECT_REGION'),
  awsUserPoolId: fromVite('VITE_AWS_USER_POOL_ID'),
  awsUserPoolClientId: fromVite('VITE_AWS_USER_POOL_CLIENT_ID'),
  langsmithEuProjectUrl: fromVite('VITE_LANGSMITH_EU_PROJECT_URL'),
};
